import React from "react";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Tabs } from "antd";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import UpcommingGroups from "./UpcommingGroups";
import DepartureGroups from "./DepartureGroups";
import { Container } from "reactstrap";
import { useSystem } from "@/utils/hooks/useLocation";

export const MakkahGroups = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
const { currentSystem, location } = useSystem()

  const items = [
    {
      key: "upcoming",
      label: t("MAKKAH_GROUPS_UPCOMING"),
      children: <UpcommingGroups />,
    },
    {
      key: "departure",
      label: t("MAKKAH_GROUPS_DEPARTURE"),
      children: <DepartureGroups />,
    },
  ];

  const onChange = (key) => {
    navigate(`/app/${currentSystem}/groups-${key}`);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("MAKKAH_GROUPS_TITLE")} />
      <Container fluid>
        <Tabs
          activeKey={
            location.pathname.endsWith("-departure") ? "departure" : "upcoming"
          }
          items={items}
          onChange={onChange}
        />
      </Container>
    </Stack>
  );
};

export default MakkahGroups;
